<div class="pedido-itens-modal-fotos">
  <div class="form-row">
    <div class="form-group col-sm-12">
      <label><b>Produto:</b></label>

      <input class="form-control form-control-sm" type="text" name="produto_foto" [value]="produtoSelecionado != null ? produtoSelecionado.name : ''" disabled />
    </div>
  </div>

  <hr class="mt-2 mb-2" />

  <div class="pedido-itens-modal-fotos-gallery">
    @for (produtoFoto of fotos; track produtoFoto) {
      <div class="pedido-itens-modal-fotos-photo">
        <img class="pedido-itens-modal-fotos-img" [src]="produtoFoto.imagem" alt="Foto" />
      </div>
    }
  </div>
</div>
